import {type FunctionalComponent, h} from '@stencil/core';
import type {SortOptionResponse} from '../../../../../models/cose-api/response/result-response.dto';
import {viewType} from '../../../../../constants/viewTypeConstants';
import ICON_LIST_VIEW from '../../../../../assets/svg/ICON_LIST_VIEW.svg';
import ICON_GRID_VIEW from '../../../../../assets/svg/ICON_GRID_VIEW.svg';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';


export interface GridSwitchButton {
    gridViewSwitch: boolean
    switchGridView: CallableFunction
    gridView: boolean
    accessibilityMode: boolean
    labelProvider: labelProviderInterface
}

export const GridSwitchButton: FunctionalComponent<GridSwitchButton> = (props) => {

    const { gridViewSwitch, switchGridView, gridView, accessibilityMode, labelProvider } = props;


    return ( gridViewSwitch ?
      <span class={'view_selector_container'}>
        <button
          id={'view_selector'}
          onClick={() =>
            switchGridView(
              viewType.LIST
            )
          }
          class={{
            isSelected: !gridView,
            accessibility:accessibilityMode
          }}
          style={{
            'margin-right': '12px'
          }}
        >
          <span
            class="view_selector_icon"
            innerHTML={
              ICON_LIST_VIEW
            }
          ></span>
          <span class="view_selector_text">
            {labelProvider(
              'LISTVIEW',
              'List View'
            )}
          </span>
        </button>
        <button
          id={'view_selector'}
          onClick={() =>
            switchGridView(
              viewType.GRID
            )
          }
          class={{
            isSelected:gridView,
            accessibility:accessibilityMode
          }}
        >
          <span
            class="view_selector_icon"
            innerHTML={
              ICON_GRID_VIEW
            }
          ></span>
          <span class="view_selector_text">
            {labelProvider(
              'GRIDVIEW',
              'Grid View'
            )}
          </span>
        </button>
      </span>
      : (
        ''
      )
    );
};
